import React, { useEffect } from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { initialState as goldInitialState } from '~redux/slices/gold';

import SearchAndFilterBar, { TSearchAndFilterBarProps } from '~components/molecules/SearchAndFilterBar';

import { TGetInventoryListingFilters } from '~types/feat/gold';

import * as Styles from './_inventoryListingSearchAndFilterBar.module.scss';
import { BranchStatusEnum } from '~utils/enums';

const InventoryListingSearchAndFilterBar = () => {
    const dispatch = useAppDispatch();

    const filters = useAppSelector(state => state.gold.goldInventory.inventoryListing.filters);
    const branchesList = useAppSelector(state => state.branch.allBranches);
    const { allBranchAccess, branchCode } = useAppSelector(state => state.auth.userDetails);
    const initialFilters = goldInitialState.goldInventory.inventoryListing.filters;

    const branchOptions = branchesList.filter(branch => branch.status === BranchStatusEnum.Active);

    const setFilters = (inputFilters: TGetInventoryListingFilters) => dispatch(combinedActions.goldSetInventoryListingFilters(inputFilters));
    const handleSearchClick = () => dispatch(combinedActions.goldGetInventoryListingAttempt());
    const handleCancelClick = () => {
        setFilters({
            ...initialFilters,
            branchCode: !allBranchAccess ? branchCode : '',
            branchName: !allBranchAccess ? (branchOptions.find((branch) => branch.branchCode === branchCode)?.branchName || '') : '',
        });
        dispatch(combinedActions.goldGetInventoryListingAttempt());
    };

    useEffect(() => {
        if (branchesList.length === 0) return;

        const defaultBranch =
            !allBranchAccess
                ? branchesList.find(b => b.branchCode === branchCode)
                : branchesList[0];

        if (!defaultBranch) return;

        setFilters({
            ...filters,
            branchName: defaultBranch.branchName,
            branchCode: defaultBranch.branchCode,
        });

    }, [branchesList]);

    useEffect(() => {
        return () => {
            // clear filters on unmount
            handleCancelClick();
        };
    }, []);

    const massagedBranchesListOption = () => {
        if (!branchOptions.length) return [];
        return branchOptions.map((branch) => ({
            label: branch.branchName,
            value: branch.branchCode,
        }));
    };

    const fields: TSearchAndFilterBarProps['fields'] = [
        {
            label: 'Branch:',
            type: 'dropdown' as const,
            dropdownParams: {
                options: massagedBranchesListOption(),
                value: filters.branchName,
                setValue: (event: React.ChangeEvent<HTMLInputElement>) => setFilters({
                    ...filters,
                    branchName: event.target.value,
                    branchCode: branchOptions.find((branch) => branch.branchName === event.target.value)?.branchCode || '',
                }),
                optionSelected: !!branchOptions.find((branch) => branch.branchName === filters.branchName),
                noOptionsMessage: 'No branch found',
                disabled: !allBranchAccess,
            },
        },
    ];

    return (
        <SearchAndFilterBar
            fields={fields}
            searchOnClick={handleSearchClick}
            cancelOnClick={handleCancelClick}
            containerClassName={Styles['content-container']}
        />
    );
};

export default InventoryListingSearchAndFilterBar;
